import { FC } from 'react';

import { Button } from 'antd';

import { useTranslation } from 'react-i18next';
import styles from './SchedulerFooter.module.scss';

interface SchedulerFooterProps {
  onConfirm: () => void;
}

const SchedulerFooter: FC<SchedulerFooterProps> = ({ onConfirm }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.footerContainer}>
      <Button className={styles.btn} type="primary" onClick={onConfirm}>
        {t('common.confirm')}
      </Button>
    </div>
  );
};

export default SchedulerFooter;
